/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line

import { Divider, Button, message } from 'antd'

// import SimplePopover from '../../../components/SimplePopover'
import * as MachineUtils from '../../../business/machine.utils'
import { machineStore } from '../../../store/list/MachineModel'
import { agentAction } from '../../../action/agent'
import { machineAction } from '../../../action/machine'

const onChangeMachineStatus = (machineId: any, action: string) => {
  machineAction.publishMachine(machineId, action)
    .then(responseData => {
      message.info('机器上下线请求发送成功')
      machineStore.reloadCurrentPage()
    })
    .catch((err) => {
      message.warning(err.message)
    })
}

const onBindMachine = (machineId: any) => {
  agentAction.bindMachine(machineId)
    .then(responseData => {
      message.info('机器绑定请求发送成功')
      machineStore.reloadCurrentPage()
    })
    .catch((err) => {
      message.warning(err.message)
    })
}

export default (props: { text: any, record: any }) => {
  return <span>
    {/* <SimplePopover title="主机管理" text="主机管理">
      <Button size="small" block>同步信息</Button>
    </SimplePopover> */}
    {
      MachineUtils.isMachineNeedSync(props.record) && <span>
        <Button
          type="link"
          size="small"
          onClick={() => { onBindMachine(props.record.machine_id) }}
        >绑定</Button>
        <Divider type="vertical" />
      </span>
    }
    <Button
      size="small"
      type="link"
      onClick={() => {
        onChangeMachineStatus(props.record.machine_id, 'publish')
      }}
    >上线</Button>
    <Divider type="vertical" />
    <Button size="small" type="link" onClick={() => { onChangeMachineStatus(props.record.machine_id, 'hidden') }}>下线</Button>
  </span>
}
